import { useEffect, useContext, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";

import CanvasArea from "../../components/photographer/CanvasArea";
import CommentModal from "../../components/photographer/CommentModal";
import ThumbnailList from "../../components/photographer/ThumbnailList";

const PhViewFeedback = (props) => {

  const { psid, origid, fname } = useParams();
  const fileInputRef = useRef(null);
  
  // active image index
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeImage, setActiveImage] = useState([]);
  const [aiFeedback, setAiFeedback] = useState([]);
  
  useEffect(() => {
    axios
        .get(Utils.apiUrl(`photoshoot/photos?psid=${psid}&origid=${origid}`), Utils.apiHeaders())
        .then((res) => {
            if(res.data.success) {
              var pimages = res.data.data;
              var actindex = pimages.findIndex(item => item.fname === fname);
              console.log('actindex', actindex);
              if(actindex == -1) actindex = 0;
              console.log(pimages[actindex]);
              setAiFeedback(pimages[actindex].ai_feedback);
              setActiveIndex(actindex);
              setPhotoshootImages(res.data.data);
              setActiveImage(pimages[actindex]);
            }
        })
        .catch((err) => {
        //callback(false, err.message);
        });
  }, [])

  useEffect(() => {
    if (photoshootImages.length > 0 && activeIndex < photoshootImages.length) {
      const img = photoshootImages[activeIndex];
      setActiveImage(img);
      setAiFeedback(img.ai_feedback);
    }
  }, [activeIndex, photoshootImages]);

  // store per-image data: { [imageId]: { strokes: [...], comments: [...], image: src } }
  const [imageDataMap, setImageDataMap] = useState({});

  // comment modal state handled by CanvasArea -> forwarded here for global display if needed
  const [jsonOutput, setJsonOutput] = useState("");

  // Optional: backend endpoint placeholder (set to null to disable POST)
  let BACKEND_SAVE_URL = null; // e.g. "/api/visual-analyzer/save"

  // Called by CanvasArea when strokes/comments changed (autosave to local memory)
  const handleUpdateImageData = useCallback((imageId, data) => {
    setImageDataMap((prev) => ({ ...prev, [imageId]: data }));
  }, []);



  /* For Drag and Drop Images  */
  // Drag and drop handlers for Recce Images
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  /* const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('recces', files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/recces/${id}`), formData, Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            updateRecceImages();
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error('Upload failed:', err);
          // Optionally, show error message
        });
    }
  }; */

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const submitUpdatedImage = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    formData.append('psid', activeImage.photoshoot_id);
    formData.append('origid', (activeImage.orig_photo_id == null) ? activeImage.id : activeImage.orig_photo_id);
    formData.append('previd', activeImage.id);
    // Add attachments
    const files = frm.photo.files;
    for (let i = 0; i < files.length; i++) {
      formData.append('photo', files[i]);
    }
    
    axios
        .post(Utils.apiUrl(`photoshoot/photo`), formData, Utils.apiHeaders())
        .then((res) => {
          console.log(res.data);
          if(res.data.success) {
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });

  }

  const submitReply = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    formData.append('photoId', activeImage.id);
    formData.append('remark', frm.remark.value);
    
    axios
        .put(Utils.apiUrl(`photoshoot/photo-remark`), formData, Utils.apiHeaders())
        .then((res) => {
          console.log(res.data);
          if(res.data.success) {
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });

  }

  return (
    <>
      <div class="page-wrap">
        <header className="bg-white shadow-md py-4 px-8 flex justify-between items-center header">
            <div class="text-xl font-bold text-gray-800">
                <span>Brand Feedback/Comments</span>
                {/* <div className="flex gap-4">
                    <img src="/images/logo.png" className="logo" />
                </div> */}
            </div>
            <nav>
                <a href={`${process.env.REACT_APP_BASENAME}photographer-photoshoot-details/${psid}`} class="text-gray-600 hover:text-gray-800">Back</a>
            </nav>
        </header>

        <div class="block py-4 px-8"><strong>Image</strong> JW_MARRIOTT_SINGAPORE_ROOM</div>
        <main class="flex-area container mx-auto px-2">
            
            <aside class="thumb-column" aria-label="Image thumbnails">
                {photoshootImages.length > 0 && <ThumbnailList
                  images={photoshootImages}
                  activeId={activeImage.id}
                  origid={origid}
                  onSelect={(id) => {
                    const idx = photoshootImages.findIndex((i) => i.id === id);
                    if (idx >= 0) setActiveIndex(idx);
                  }}
                />}
            </aside>

            <section class="preview" aria-live="polite">
                <CanvasArea
                    key={activeImage.id} // re-mount when switching images to clean internal transient state
                    image={activeImage}
                    savedData={imageDataMap[activeImage.id] || null}
                    onUpdate={(data) => handleUpdateImageData(activeImage.id, data)}
                />
                
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 phfeedbackform">
                    <div class="item">
                        <label class="text-base block mb-2">Brand Team Feedback</label>
                        <div class="feedback bg-gray-100 p-4 rounded-lg text-sm">
                            {activeImage.bt_feedback}
                        </div>
                    </div>
                    <div class="item">
                      <form onSubmit={submitReply}>
                        <label class="text-base block mb-2">Your Reply</label>
                        <div class="block messagetobt mb-2">
                          {activeIndex == 0 && (
                            <textarea name="remark" id="remark" placeholder="Message to Brand Team" class="border-0 rounded-lg w-full py-2 px-3 bg-white-100 border-gray-300 border focus:shadow-outline" value={activeImage.photographer_remarks}></textarea>
                          )}
                          {activeIndex > 0 && (
                            <div class="feedback bg-gray-100 p-4 rounded-lg text-sm">
                              {activeImage.photographer_remarks}
                            </div>
                          )}
                        </div>

                        {activeIndex == 0 && (
                        <div class="cta text-right">
                            <button type="submit" class="btn text-white py-1 px-4 rounded focus:outline-none focus:shadow-outline">Send</button>
                        </div>
                        )}
                        </form>
                    </div>
                    {activeIndex == 0 && (
                    <div class="item">
                      <form onSubmit={submitUpdatedImage}>
                        <label class="text-base block mb-2">Upload Revised Image</label>
                        <div id="drop-zone" class="drop-zone  mb-2" onClick={handleClick} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                            Drag &amp; Drop files here or click to select
                            <input name="photo" type="file" id="file-input" className="hidden" ref={fileInputRef} />
                        </div>
                        <div class="cta text-right">
                            <button type="submit" class="btn text-white py-1 px-4 rounded focus:outline-none focus:shadow-outline">Save</button>
                        </div>
                        </form>
                    </div>
                    )}
                </div>
            </section>
            
        </main>
    </div>
    
    </>
  );
};

export default PhViewFeedback;
